module.exports = __webpack_public_path__ + "img/google-play-badge.ea577b25.svg";